import dayjs, { dateTimeDisplayFormat } from '~libs/dayjs';

// Shared by the PRODA connection manager and the reference-data sync status view. TAV-3332: this
// used to build its own 'en-AU' Intl string, which read as "25 Sept 2026, 01:21 pm" instead of the
// standard 'DD/MMM/YYYY hh:mm A' every other screen uses. `dayjs(value)` with no explicit format
// string parses ISO-8601 (including a trailing 'Z') natively, so the concern that motivated a
// custom formatter here (~libs/dayjs's formatDayTimeString re-parsing with the explicit format
// 'YYYY-MM-DD HH:mm', which does not reliably handle these APIs' 'Z' timestamps) does not apply to
// a plain dayjs parse.
const formatDate = (value: string | null | undefined): string => {
  if (!value) return '—';
  return dayjs(value).format(dateTimeDisplayFormat);
};

export default formatDate;
